import React from 'react';
import { 
  TextField,
  Box
} from '@mui/material';

/**
 * Component for personal information form fields
 */
const PersonalInfoFields = ({ register, errors }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* First Name Field */}
      <TextField
        label="Voornaam *"
        {...register('firstName', { required: 'Voornaam is verplicht' })}
        error={!!errors.firstName}
        helperText={errors.firstName?.message}
        InputLabelProps={{ shrink: true }}
      />

      {/* Last Name Field */}
      <TextField
        label="Achternaam *"
        {...register('lastName', { required: 'Achternaam is verplicht' })}
        error={!!errors.lastName}
        helperText={errors.lastName?.message}
        InputLabelProps={{ shrink: true }}
      />

      {/* Alias Field (Optional) */}
      <TextField
        label="Alias (naam tijdens sessie)"
        {...register('alias')}
        InputLabelProps={{ shrink: true }}
      />

      {/* Email Field */}
      <TextField
        label="E-mail *"
        type="email"
        {...register('email', { 
          required: 'E-mail is verplicht',
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'Ongeldig e-mailadres'
          }
        })}
        error={!!errors.email}
        helperText={errors.email?.message}
        InputLabelProps={{ shrink: true }}
      />

      {/* Birth Date Field */}
      <TextField
        label="Geboortedatum"
        type="date"
        InputLabelProps={{ shrink: true }}
        {...register('birthDate')}
        error={!!errors.birthDate}
        helperText={errors.birthDate?.message}
      />
    </Box>
  );
};

export default PersonalInfoFields; 